import React, { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import loginimage from '../../images/amazing gems and jewellery png with name.png';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Swal from 'sweetalert2';
import Cookies from 'universal-cookie';
import { jwtDecode } from 'jwt-decode';

const GuestLoginModal = ({ show, onClose }) => {
    const [email, setemail] = useState('');
    const [contactNo, setContactNo] = useState('');
    const [name, setname] = useState('');
    const [otp, setOtp] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmitGuestlogin = async (event) => {
        event.preventDefault();
        setLoading(true);
        const common_id = localStorage.getItem('common_id') ? localStorage.getItem('common_id') : '';

        try {
            const response = await fetch('https://backend.indianjewelryish.com/api/guest-register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ common_id: common_id, name: name, email: email, contact_no: contactNo }),
            });
            const data = await response.json();

            if (data.token && data.user_id) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('user_id', data.user_id);
                localStorage.setItem('user_name', data.user_name);

                const decodedToken = jwtDecode(data.token);
                const expiryDate = new Date(decodedToken.exp * 1000);

                const cookies = new Cookies();
                cookies.set('user_id', data.user_id, { expires: expiryDate });

                onClose();
                Swal.fire({
                    icon: 'success',
                    confirmButtonColor: '#b63f23',
                    title: 'Guest Login Successful!',
                });
            } else {
                console.error('Token or UserId missing in response');
                onClose();
                Swal.fire({
                    icon: 'warning',
                    confirmButtonColor: '#b63f23',
                    title: 'Login Failed ! ' + (data.message || 'Unknown error'),
                });
            }
        } catch (error) {
            console.error('Error during guest login:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyEmail = async () => {
        if (email && name && contactNo) {
            setLoading(true);
            try {
                const response = await fetch('https://backend.indianjewelryish.com/api/send-otp', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ email }),
                });

                const data = await response.json();

                if (!response.ok) {
                    setError(data);
                    Swal.fire({
                        icon: 'warning',
                        confirmButtonColor: '#b63f23',
                        title: 'Failed to sign up: ' + (data.message || 'Unknown error'),
                    });
                    return;
                }

                setError(null);
                document.querySelector('.verifyEmail').style.display = 'none';
                document.querySelector('#fromVerifyEmail').style.display = 'block';
                document.querySelector('.resendOtp').style.display = 'none';
            } catch (error) {
                setError('An error occurred while signing up.');
            } finally {
                setLoading(false);
            }
        } else {
            Swal.fire({
                icon: 'warning',
                confirmButtonColor: '#b63f23',
                title: 'Fill All Fields:',
            });
        }
    };

    const handleVerifyOtpSubmit = async (e) => {
        e.preventDefault();
        if (otp) {
            setLoading(true);
            try {
                const response = await fetch('https://backend.indianjewelryish.com/api/verify-otp', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ email, otp }),
                });

                const data = await response.json();

                if (!response.ok) {
                    setError(data);
                    Swal.fire({
                        icon: 'warning',
                        confirmButtonColor: '#b63f23',
                        title: 'Failed to Verify !',
                    });
                    document.querySelector('#fromVerifyEmail').style.display = 'none';
                    document.querySelector('.resendOtp').style.display = 'block';
                    setOtp('');
                    return;
                }

                setError(null);
                document.querySelector('#fromVerifyEmail').style.display = 'none';
                document.querySelector('.SignupSubmitButton').style.display = '';
                document.querySelector('#otpVerifiedMsg').style.display = 'block';
            } catch (error) {
                setError('An error occurred while signing up.');
            } finally {
                setLoading(false);
            }
        } else {
            Swal.fire({
                icon: 'warning',
                confirmButtonColor: '#b63f23',
                title: 'Fill OTP',
            });
        }
    };

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div className="popupcontainerls">
                    <img id='loginsignupimage' src={loginimage} alt="Login" />
                    <div className="popupcontainer">
                        <h1>Guest Login</h1>
                        <form onSubmit={handleSubmitGuestlogin}>
                            <input
                                className='loginsignupinput'
                                type="text"
                                placeholder='Enter Name'
                                value={name}
                                onChange={(e) => setname(e.target.value)}
                                required
                            />
                            <input
                                className='loginsignupinput'
                                type="email"
                                placeholder='E-mail'
                                value={email}
                                onChange={(e) => setemail(e.target.value)}
                                required
                            />
                            <PhoneInput
                                placeholder="Enter phone number"
                                value={contactNo}
                                onChange={setContactNo}
                                className="form-input"
                                required
                            />
                            <p className="discount" id='otpVerifiedMsg' style={{ display: 'none', textAlign: 'center' }}>OTP Verified!</p>
                            <div id='butdiv' className='SignupSubmitButton' style={{ display: 'none' }}>
                                <button className="loginsignupbutton" type='submit' disabled={loading}>
                                    {loading ? <Spinner animation="border" size="sm" /> : 'Submit'}
                                </button>
                            </div>
                        </form>
                        <div id='butdiv' className='resendOtp' style={{ display: 'none' }}>
                            <button className="loginsignupbutton" onClick={handleVerifyEmail} disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : 'Re-send OTP'}
                            </button>
                        </div>
                        <div id='butdiv' className='verifyEmail'>
                            <button className="loginsignupbutton" onClick={handleVerifyEmail} disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : 'Verify Email'}
                            </button>
                        </div>
                        <form id='fromVerifyEmail' style={{ display: 'none' }} onSubmit={handleVerifyOtpSubmit}>
                            <input
                                style={{ border: '2.2px solid black' }}
                                className='admininput mt-2'
                                type="text"
                                value={otp}
                                placeholder='Enter OTP'
                                onChange={(e) => setOtp(e.target.value)}
                                required
                            />
                            <div id='butdiv'>
                                <button className="loginsignupbutton" type="submit" disabled={loading}>
                                    {loading ? <Spinner animation="border" size="sm" /> : 'Verify'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default GuestLoginModal;
